import axios from '@/libs/api.request'

// 获取客服电话
export const getServicePhone = () => {
  return axios.request({
    url: 'option/phoneget',
    method: 'post'
  })
}

// 更新客服电话
export const updateServicePhone = (data) => {
  return axios.request({
    url: 'option/phoneUpdate',
    data: data,
    method: 'post'
  })
}

// 获取仪表盘数据
export const getDashboardData = () => {
  return axios.request({
    url: 'dashboard/data',
    method: 'get'
  })
}

/** 今日点餐营业额（订单页顶部） */
export const getFoodTodayStats = () => {
  return axios.request({
    url: 'dashboard/food-today',
    method: 'get'
  })
}

/** 商品销售报表 */
export const getFoodSalesReport = (params) => {
  return axios.request({
    url: 'dashboard/food-sales-report',
    method: 'get',
    params: params || {}
  })
}

/** 营业额按日汇总（净营业额） */
export const getFoodRevenueSummary = (params) => {
  return axios.request({
    url: 'dashboard/food-revenue-summary',
    method: 'get',
    params: params || {}
  })
}

/** 退款流水 */
export const getFoodRefundLedger = (params) => {
  return axios.request({
    url: 'dashboard/food-refund-ledger',
    method: 'get',
    params: params || {}
  })
}